export default function manipulateTabs() {
  const isPresent = document.querySelector("[data-main-tab-control]");
  if (!isPresent) {
    return;
  }

  if (window.matchMedia("(max-width: 700px)").matches) {
    const blocks = document.querySelectorAll(".v2-tabs-intersector");

    const config = {
      rootMargin: "0px 0px 0px 0px",
      // threshold: [0.5, 1],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          document.body.classList.add("v2-tabs-section-inview");
        } else {
          document.body.classList.remove("v2-tabs-section-inview");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });

    function simulateTabClick() {
      const btns = document.querySelectorAll("[data-tab-no]");

      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          btns.forEach((btn) => {
            btn.classList.remove("active");
          });

          btn.classList.add("active");

          const tabValue = btn.getAttribute("data-tab-no");

          console.log(tabValue);

          document.querySelector(`[aria-controls=${tabValue}]`).click();
        });
      });
    }

    simulateTabClick();

    function simulateAltTabClick() {
      const btns = document.querySelectorAll("[data-main-tab-control]");

      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const tabValue = btn.getAttribute("aria-controls");

          console.log(tabValue);

          document.querySelector(`[data-tab-no=${tabValue}]`).click();
        });
      });
    }

    simulateAltTabClick();
  }
}
